import { useAtom, useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'
import * as R from 'remeda'

import { CustomerAttributeSelector } from '~/components/features/CustomerAttributeSelector'
import {
  EditDiffButton,
  type EditDiffButtonProps,
} from '~/components/features/EditDiffButton'
import { useSurveyQueryFlattenCustomerAttributes } from '~/hooks/useSurveyQuery'
import { differenceBy, intersectionBy } from '~/utils'

import { columnsDiffsAtom, countColumnKeysAtom } from '../atoms'
import { allKey, type ColumnsDiff } from '../utils'

export const EditColumnCustomerAttributesDiffButton = () => {
  const [columnsDiffs, setColumnsDiffs] = useAtom(columnsDiffsAtom)

  const customerAttributes = useSurveyQueryFlattenCustomerAttributes()
  const countColumnKeys = useAtomValue(countColumnKeysAtom)
  const { t } = useTranslation()

  const renderSelector = React.useMemo<EditDiffButtonProps['renderSelector']>(
    () => (field, anotherFieldValue) => (
      <CustomerAttributeSelector
        {...field}
        customerAttributes={R.pipe(
          [{ id: allKey, name: t('overall') }, ...customerAttributes],
          intersectionBy(countColumnKeys, R.prop('id'), R.identity()),
          differenceBy([anotherFieldValue], R.prop('id'), R.identity()),
        )}
        width={240}
      />
    ),
    [countColumnKeys, customerAttributes, t],
  )

  const handleExecute = React.useCallback<EH<EditDiffButtonProps, 'onExecute'>>(
    (diffs) => {
      setColumnsDiffs(diffs as ColumnsDiff[])
    },
    [setColumnsDiffs],
  )

  return (
    <EditDiffButton
      diffs={columnsDiffs}
      renderSelector={renderSelector}
      onExecute={handleExecute}
    />
  )
}
